import { toast } from "react-toastify"

import { addFailedPrint, store } from "@redux"
import websocketApi from "./websocketApi"
import isInPosDevice from "./isInPosDevice"
import RNWebViewApi from "./RNWebViewApi"

const createMessage = (data) => {
  const printerSettings =
    data.printRequest.printerSettings

  const isRedirectRequest =
    !!printerSettings.localPrintServerIpAddress

  return {
    ...data,
    localPrintServerIpAddress: printerSettings.localPrintServerIpAddress,
    type: isRedirectRequest ? "redirectPrintRequest" : "printRequest",
    forPos: printerSettings.forPos,
    printerSettings
  }
}

const webSocketExectuer = async (resolve, reject, data) => {
  const saveToFailedPrints =
    data.printRequest.saveToFailedPrints

  const printerName =
    data.printRequest.printerSettings.printerName

  const message = createMessage(data)

  try {
    const response =
      await websocketApi.send(message)

    if (response.success) return resolve()

    reject(response.errorMessage)

    saveToFailedPrints &&
      store.dispatch(
        addFailedPrint(data.printRequest)
      )

    toast.error(`پرینت (${printerName}) انجام نشد`)
  } catch (err) {
    reject(err)

    saveToFailedPrints &&
      store.dispatch(
        addFailedPrint(data.printRequest)
      )

    toast.error(`پرینت (${printerName}) انجام نشد`)
  }
}

const webViewExectuer = async (resolve, reject, data) => {
  const saveToFailedPrints =
    data.printRequest.saveToFailedPrints

  const printerName =
    data.printRequest.printerSettings.printerName

  const message = createMessage(data)

  try {
    const response =
      await RNWebViewApi.postMessage(message)

    if (response.success) return resolve()

    reject("error")

    saveToFailedPrints &&
      store.dispatch(
        addFailedPrint(data.printRequest)
      )

    toast.error(`پرینت (${printerName}) انجام نشد`)
  } catch (err) {
    reject("error")

    saveToFailedPrints &&
      store.dispatch(
        addFailedPrint(data.printRequest)
      )

    toast.error(`پرینت (${printerName}) انجام نشد`)
  }
}

const sendPrintRequest = (data) => (
  new Promise((resolve, reject) => {
    if (isInPosDevice()) {
      return webViewExectuer(resolve, reject, data)
    }

    return webSocketExectuer(resolve, reject, data)
  })
)

export default sendPrintRequest